import { render, staticRenderFns } from "./AdvertisementBenefitSelection.vue?vue&type=template&id=b4359da8&"
import script from "./AdvertisementBenefitSelection.vue?vue&type=script&lang=js&"
export * from "./AdvertisementBenefitSelection.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementBenefitSelection.vue?vue&type=style&index=0&id=b4359da8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports